
export default {
  name: 'DashboardError',
  layout: 'dashboard',
  props: {
    error: {
      type: Object,
      default: null
    },
    hideButton: Boolean
  },
  data () {
    return {
      shareCode: ''
    }
  },
  computed: {
    errorCode () {
      return this.error?.statusCode || 404
    },
    translationErrorCode () {
      if ([404, 500].includes(this.errorCode)) {
        return this.errorCode
      }

      return 500
    }
  },
  mounted () {
    this.shareCode = window.btoa(JSON.stringify(this.error))
    console.error('error:', JSON.parse(JSON.stringify(this.error)))
  }
}
